"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _default2 = {
  props: {
    getRenderContainer: {
      type: [Function, String],
      "default": function _default() {
        return document.body;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    mountContainer: function mountContainer() {
      var container;

      if (typeof this.getRenderContainer === 'string') {
        container = document.querySelector(this.getRenderContainer);
      } else if (typeof this.getRenderContainer === 'function') {
        container = this.getRenderContainer();
      }

      if (container) {
        container.appendChild(this.$el);
      }
    }
  }
};
exports["default"] = _default2;